// Ui
import Text from 'ui3/Text/Text';
// Components
import ItemAmount from 'components/common3/ItemAmount/ItemAmount';

export type QuantityAndPriceClassNames = {
  wrapper: string;
  quantityAndPrice: string;
  quantity?: string;
  priceValue?: string;
};

type QuantityAndPriceProps = {
  maxQuantity: number;
  value: number;
  onChange: (amount: number) => void;
  totalPrice: string;
  showQuantitySelector: boolean;
  classNames: QuantityAndPriceClassNames;
};

const QuantityAndPrice = ({
  maxQuantity,
  value,
  onChange,
  totalPrice,
  showQuantitySelector,
  classNames,
}: QuantityAndPriceProps) => {
  const { wrapper, quantityAndPrice, quantity, priceValue } = classNames;

  if (showQuantitySelector) {
    return (
      <div className={wrapper}>
        <Text variant="subtitle2">Quantity:</Text>
        <div className={quantityAndPrice}>
          {quantity ? (
            <div className={quantity}>
              <ItemAmount
                maxQuantity={maxQuantity}
                value={value}
                onChange={onChange}
              />
            </div>
          ) : (
            <ItemAmount
              maxQuantity={maxQuantity}
              value={value}
              onChange={onChange}
            />
          )}
          <Text variant="h5">{totalPrice}</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={wrapper}>
      <Text variant="subtitle2">Price:</Text>
      <Text variant="h5" className={priceValue || undefined}>
        {totalPrice}
      </Text>
    </div>
  );
};

export default QuantityAndPrice;
